<template>
  <div>
    <!-- Bottone trigger -->
    <button 
      @click="showModal = true"
      class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      {{ selectedClient ? selectedClient : $t('ui.client_selector_modal.select_client') }}
    </button>
    
    <!-- Indicatore filtro attivo -->
    <span v-if="selectedClient" class="text-sm text-gray-600 ml-2">
      {{ $t('ui.client_selector_modal.active_filter') }} <strong>{{ selectedClient }}</strong>
      <button 
        @click="clearSelection" 
        class="ml-2 text-red-500 hover:text-red-700"
        :title="$t('ui.client_selector_modal.remove_filter')"
      >
        ✕
      </button>
    </span>

    <!-- Modal -->
    <div v-if="showModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
        <h3 class="text-lg font-semibold mb-4">{{ $t('ui.client_selector_modal.choose_client_title') }}</h3>
        
        <!-- Campo di ricerca -->
        <div class="mb-4">
          <input 
            v-model="searchQuery"
            type="text"
            :placeholder="$t('ui.client_selector_modal.search_placeholder')"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            @keydown.escape="showModal = false"
          />
        </div>
        
        <div class="max-h-60 overflow-y-auto">
          <div class="space-y-2">
            <button 
              @click="selectClient('')"
              class="w-full text-left px-3 py-2 rounded hover:bg-gray-100"
              :class="{ 'bg-blue-200': selectedClient === '' }"
            >
              <strong>{{ $t('ui.client_selector_modal.all_clients') }}</strong>
            </button>
            <button 
              v-for="client in filteredClients" 
              :key="client"
              @click="selectClient(client)"
              class="w-full text-left px-3 py-2 rounded hover:bg-gray-100"
              :class="{ 'bg-blue-200': selectedClient === client }"
            >
              {{ client }}
            </button>
          </div>
        </div>
        
        <!-- Messaggio quando nessun cliente corrisponde alla ricerca -->
        <div v-if="filteredClients.length === 0 && searchQuery" class="text-center text-gray-500 py-4">
          {{ $t('ui.client_selector_modal.no_clients_found', { query: searchQuery }) }}
        </div>
        
        <div class="flex justify-end mt-4">
          <button 
            @click="showModal = false"
            class="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            {{ $t('ui.client_selector_modal.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clientsList: {
      type: Array,
      required: true
    },
    selectedClient: {
      type: String,
      default: ''
    }
  },
  emits: ['client-selected'],
  data() {
    return {
      showModal: false,
      searchQuery: ''
    }
  },
  computed: {
    filteredClients() {
      if (!this.searchQuery) {
        return this.clientsList.slice().filter(x => x != null).sort((a, b) => a.localeCompare(b));
      }
      return this.clientsList.filter(x => x != null)
        .filter(client => 
          client.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
        .sort((a, b) => a.localeCompare(b));
    }
  },
  methods: {
    selectClient(client) {
      this.$emit('client-selected', client);
      this.showModal = false;
      this.searchQuery = ''; // Reset search when closing
    },
    clearSelection() {
      this.$emit('client-selected', '');
    }
  },
  watch: {
    showModal(newValue) {
      if (!newValue) {
        this.searchQuery = ''; // Reset search when modal closes
      }
    }
  }
}
</script>
